import { isPlatformServer } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  APP_ID,
  ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideExperimentalZonelessChangeDetection,
  signal,
} from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import {
  AUTH_COMPONENT_TOKEN,
  authInterceptor,
  CustomTranslateLoader,
  EMPTY_DRIVER,
  errorTranslationInterceptor,
  GbTheme,
  LocalStorageDriver,
  provideScrollRestoration,
  refreshTokenInterceptor,
  THEME_SIGNAL,
} from '@gb-webapp/gb-app';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { appRoutes } from './app.routes';
import { AuthComponent } from './pages/auth/auth.component';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_ID, useValue: 'gb-webapp-yez' },
    provideRouter(appRoutes),
    provideScrollRestoration(),
    provideExperimentalZonelessChangeDetection(),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withInterceptors([authInterceptor, refreshTokenInterceptor, errorTranslationInterceptor]),
      withFetch()
    ), // ✅ modern way
    provideTranslateService({
      loader: provideTranslateLoader(CustomTranslateLoader),
    }),
    {
      provide: LocalStorageDriver,
      useFactory: () => {
        const platform = inject(PLATFORM_ID);
        if (isPlatformServer(platform)) {
          return EMPTY_DRIVER;
        }

        return globalThis.localStorage;
      },
    },
    {
      provide: THEME_SIGNAL,
      useValue: signal(GbTheme.ThemeOne),
    },
    {
      provide: AUTH_COMPONENT_TOKEN,
      useValue: AuthComponent,
    },
  ],
};
